const config = {
  API_ENDPOINT: 'https://portal.fabpik.in/api',
};

export default config;
